module.exports = __webpack_public_path__ + "static/media/image_upload_placeholder.f551fb3a.svg";